import { createAsyncActionConstants } from 'utilities/util';

export const TYPES = {
    ADD_CUSTOMER: createAsyncActionConstants('ADD_CUSTOMER')
};
